import { TSkuItem } from "@elixir/types";
import { GET_AXON_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import { AxonGenericApiResponse } from "../../types/axon";

export type TPutServicesMasterRequestProps = {
  service_name: string;
  price: number;
  service_id: number;
  clinic_id: string;
  body: Partial<Omit<TSkuItem, "service_id">> & { clinic_id: string };
};

export default async function putUpdateServicesMaster(
  serviceUpdateData: TPutServicesMasterRequestProps
): Promise<AxonGenericApiResponse<{}>> {
  const AXON_HOST = GET_AXON_HOST();
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "PUT",
    headers: myHeaders,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
    body: JSON.stringify(serviceUpdateData),
  };

  const response = await fetch(
    `${AXON_HOST}/autosuggest/services-master`,
    requestOptions
  );
  return await response.json();
}
